import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
 
export default (app:any) => {
  app.use(ElementPlus)
  app._context.components.ElDialog.props.closeOnClickModal.default = false
  app._context.components.ElDialog.props.closeOnPressEscape.default = false
  app._context.components.ElDrawer.props.closeOnClickModal.default = false
  app._context.components.ElDrawer.props.closeOnPressEscape.default = false
}